import CanisterModal, { CanisterFormValues } from '../../components/location-management/CanisterModal';
import { StorageCanister, StorageSite, StorageTank } from '../../types/interfaces';
import { createStorageCanister, updateStorageCanister } from '../../api/storageItemsApi';

type RsgCanisterModalProps = {
  mode: 'add' | 'edit';
  close: () => void;
  site: StorageSite;
  tank: StorageTank;
  canister?: StorageCanister;
  setSelectedId?: (id: number) => void;
};

const RsgCanisterModal = ({ mode, close, site, tank, canister, setSelectedId }: RsgCanisterModalProps): JSX.Element => {
  const canisterValues = canister ? { name: canister.name, active: canister.active } : undefined;

  const createCanister = async ({ name, active }: CanisterFormValues) => {
    const { data: id } = await createStorageCanister({
      name,
      active,
      storageTankId: tank.storageTankId,
    });
    return id;
  };

  const updateCanister = async ({ name, active }: CanisterFormValues) => {
    if (!canister) {
      return;
    }
    await updateStorageCanister(canister.storageCanisterId, { name, active });
  };

  return (
    <CanisterModal
      mode={mode}
      close={close}
      siteName={site.name}
      tankName={tank.name}
      canister={canisterValues}
      setSelectedId={setSelectedId}
      createCanister={createCanister}
      updateCanister={updateCanister}
    />
  );
};

export default RsgCanisterModal;
